import React from 'react';
import { TableBody } from '@material-ui/core';
import { isFlightOpen } from "../util/isFlightOpen";
import { MobileResult } from './mobile';
import { DesktopResult } from './desktop'
import _ from 'lodash'

export const Result = (props) => {
  const { row, modalClasses, isMobile, newTexts, date } = props;
  let betterRow = typeof row === 'object' ? _.cloneDeep(row) : {}
  betterRow.status = isFlightOpen(betterRow)
  let expand = false;
  if (betterRow.passengers && betterRow.passengers.length) {
    expand = true;
  }
  
  return (
    <React.Fragment>
      {
        isMobile ?
        <MobileResult row={row} modalClasses={modalClasses} newTexts={newTexts} date={date} /> :
        <DesktopResult row={row} modalClasses={modalClasses} newTexts={newTexts} date={date} />
      }
    </React.Fragment>
  )
}

export const Results = (props) => {
  const filteredDeps = props.filteredDeps

  if (Array.isArray(filteredDeps) && filteredDeps.length) {
    return (
      <TableBody>
        {filteredDeps.map((row, index) => (<Result key={index} row={row} index={index} {...props} />))}
      </TableBody>
    )
  }
  else {
    return (
      <div style={{margin: '15px'}}>There don't seem to be any results. Please search again or click Refresh</div>
    )
  }
}